module.exports = __webpack_public_path__ + "static/media/APCO Intl White Logo_1719597778951.03e89e3a.png";